module.exports = __webpack_public_path__ + "static/tridrone-treasure-keeper-mtg_clb-ed5142617f14d8e04e2c647b81b63021.jpg";